'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class NavbarComponent {
  menu = [{
    title: 'Home',
    state: 'main'
  }, {
    title: 'Client Order',
    state: 'order'
  }];
  isLoggedIn: Function;
  isAdmin: Function;
  getCurrentUser: Function;
  canExportOrders: Function;
  isCollapsed = true;

  constructor($uibModal, Auth) {
    'ngInject';

    this.$uibModal = $uibModal;
    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
    this.canExportOrders = Auth.canExportOrders;
  }

  openExportModal(user) {
    let self = this;
    let modalInstance = this.$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: require('../../app/order/export.modal.html'),
      controller: 'ExportModalController',
      controllerAs: '$ctrl',
      size: 'sm'
    });
    modalInstance.result.then(function() {
  
    }, function() {

    });
  }

}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js